import { APIGet, APIPost, APIPut, APIDelete, APIUrl, AdminType } from "api/protocols";
import { CancelToken } from "axios";
import { IDepartments } from "redux/reducers/models/product";

const apiVersion = "2024-04";
const adminType = "facility-admin";
const baseUrl = "/" + apiVersion + "/" + adminType + "/facility/department";

//GET Departments
export async function GetDepartments(params: { extended: boolean }, useGlobalLoader: boolean, token?: CancelToken) {
  return await APIGet<IDepartments[]>(
    APIUrl(AdminType.FacilityAdmin, "/facility/department"),
    params,
    useGlobalLoader,
    token,
  );
}

//POST Departments
export async function PostDepartments(params: Omit<IDepartments, "id">, useGlobalLoader?: boolean) {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/facility/department"), params, useGlobalLoader);
}

//PUT Departments
export async function PutDepartments(params: IDepartments, useGlobalLoader?: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/facility/department"), params, useGlobalLoader);
}

//DELETE Departments
export async function DeleteDepartments(params: IDepartments, useGlobalLoader?: boolean) {
  return await APIDelete(APIUrl(AdminType.FacilityAdmin, "/facility/department"), params, useGlobalLoader);
}

interface IDepartmentProductSettings {
  id: number;
  vendor?: any | null;
  vendor_id: any | null;
  accounting_reference?: any;
  accounting_reference_id: string | number;
  customer_required: boolean;
  fulfillment_required: boolean;
  shipping_required: boolean;
  track_inventory: boolean;
  cannot_be_sold: boolean;
  online_store: boolean;
}

//PUT Department Products
export async function UpdateAllDepartmentProducts(params: IDepartmentProductSettings, useGlobalLoader?: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/facility/department/products"), params, useGlobalLoader);
}
